export default "__VITE_ASSET__DgHj7$bS__"